var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScoringMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.81583 2.5C7.64438 2.5 7.47249 2.57434 7.3755 2.72324L5.21788 6.04825L1.38802 7.0733C1.21658 7.11891 1.08057 7.24802 1.02552 7.41737C0.970991 7.58619 1.00498 7.77203 1.11666 7.90993L3.61221 10.9902L3.40433 14.9481C3.39489 15.1253 3.47572 15.2953 3.61937 15.3996C3.66088 15.4299 3.7074 15.4517 3.75455 15.4683C3.76801 15.473 3.78175 15.4749 3.79551 15.4785C3.83064 15.4877 3.86576 15.4941 3.902 15.4959C3.91067 15.4963 3.91892 15.5 3.92761 15.5C3.93519 15.5 3.94254 15.4962 3.95013 15.4959C4.00628 15.4936 4.06211 15.4857 4.11603 15.4652L7.81583 14.0449L11.5167 15.4652C11.5775 15.4883 11.6406 15.5 11.7041 15.5C11.8131 15.5 11.9216 15.4657 12.0123 15.3996C12.1559 15.2953 12.2368 15.1253 12.2273 14.9481L12.0205 10.9902L14.515 7.90993C14.6262 7.77203 14.6612 7.58619 14.6061 7.41737C14.5511 7.24854 14.4151 7.11944 14.2436 7.0733L10.4138 6.04825L8.25616 2.72324C8.15969 2.57434 7.98728 2.5 7.81583 2.5ZM7.81583 3.97152L9.53517 6.61863L9.75431 6.95656L10.1434 7.06101L13.192 7.87716L11.2054 10.3307L10.9524 10.643L10.9729 11.0455L11.1388 14.1974L8.19165 13.0659L7.81583 12.9215V3.97152Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoringMiddle);
export default __webpack_public_path__ + "static/media/scoringMiddle.30fa1d804409129485018ed2518b386b.svg";
export { ForwardRef as ReactComponent };